import Nullstack from 'nullstack';
export default function IconLiveView({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-live-view",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), "   ", Nullstack.element("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), "   ", Nullstack.element("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), "   ", Nullstack.element("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "11",
    x2: "12",
    y2: "11.01"
  }), "   ", Nullstack.element("path", {
    d: "M12 18l-3.5 -5a4 4 0 1 1 7 0l-3.5 5"
  }), " ");
}